import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";

export interface ConfirmDialogProps {
    open?: boolean,
    title?: string,
    children: React.ReactNode,
    handleClose: () => void,
    actions: ConfirmDialogAction[],
}

export interface ConfirmDialogAction {
    label: string,
    onClick: () => void,
}

const SlideDownTransition = React.forwardRef(function Transition(
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="down" ref={ref} {...props} />;
  });

const ConfirmDialog = ({ actions, children, open, title, handleClose }: ConfirmDialogProps) => {
    return (
        <React.Fragment>
          
          <Dialog
            open={!!open}
            TransitionComponent={SlideDownTransition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {children}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
                {actions.map((action, index) => (
                    <Button  key={"action-"+index} onClick={action.onClick}>{action.label}</Button>
                ))}
            </DialogActions>
          </Dialog>
        </React.Fragment>
      );
};

export default ConfirmDialog;

